<template>
    <div class="bg-black btn-bar-nvx">
        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center" id="trackers_links">
            <div class="btn-toolbar mb-2 mb-md-0" v-show="selected">
                <div v-if="selected" class="btn-group btn-group-toggle">
                    <a :title="$t('map')" class="btn btn-sm btn-block btn-block-nvx" v-on:click="show_panel(selected, 'map')">
                        <span data-feather="map"></span>
                    </a>
                    <a :title="$t('activity')" v-if="selected.type=='tracker_02'" class="btn btn-sm btn-block btn-block-nvx"
                       v-on:click="show_panel(selected, 'activity')">{{$t('activity')}}
                    </a>
                    <a :title="$t('temperature')" v-if="show_temperature_link(selected)" class="btn btn-sm btn-block btn-block-nvx"
                       v-on:click="show_panel(selected, 'temperature')"><span data-feather="thermometer"></span>
                    </a>
                    <a :title="$t('info')" class="btn btn-sm btn-block btn-block-nvx" v-on:click="show_panel(selected, 'info')">
                        <span data-feather="info"></span>
                    </a>
                    <a v-if="user_role!='sub_user'" :title="$t('edit')" class="btn btn-sm btn-block btn-block-nvx"
                       v-on:click="show_panel(selected, 'edit')">
                        <span data-feather="edit"></span>
                    </a>
                    <a :title="$t('share')" class="btn btn-sm btn-block btn-block-nvx" v-on:click="show_panel(selected, 'share')">
                        <span data-feather="share"></span>
                    </a>
                </div>
                <div class="btn-group my-0 mx-0" v-if="selected">
                    <multiselect class="input-nvx my-0"
                                 v-model="selected_tags"
                                 track-by="id"
                                 :options="tags"
                                 :multiple="true"
                                 :clear-on-select="false"
                                 :hide-selected="true"
                                 :preserve-search="true"
                                 :select-label="$t('select')"
                                 :selected-label="$t('selected')"
                                 :deselect-label="$t('deselect_label')"
                                 @select="on_select_tag"
                                 @remove="on_remove_tag"
                                 :placeholder="$t('select_tag_tracker')"
                                 :custom-label="tag_label">
                    </multiselect>
                </div>
                <div class="btn-group my-0" v-if="selected">
                    <input class="form-control-sm col-8 input-nvx" :placeholder="$t('enter_tag')"
                           v-model="new_tag.label">
                    <button class="btn btn-sm btn-primary" v-on:click="add_tag()">{{$t('add')}}</button>
                </div>
            </div>
        </div>
    </div>

</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
    import Multiselect from 'vue-multiselect'
    import {HTTP} from "../http-constants"
    import {bus} from '../event-bus'
    import "../assets/ith_style.css"
    import "../assets/scss/style.scss"

    const feather = require('feather-icons')
    var semver = require('semver');

    export default {
        name: 'links',
        components: {
            multiselect: Multiselect,
        },
        data() {
            return {
                selected: null,
                selected_tags: [],
                tags: [],
                new_tag: {}
            }
        },
      computed: {
        user_role() {
          const role = this.$store.state.role;
          console.log("role", role);
          return role;
        },

      },
        methods: {
            'on_map': function (tracker) {
                bus.$emit('tracker_panel', {action: "map", tracker: tracker});
            },
            'select': function (tracker) {
                this.selected = tracker;
                this.update_selected_tags();
            },
            'update_selected_tags': function () {
                if (this.selected) {
                    this.selected_tags = this.tags.filter(a => a.devices.includes(this.selected.id));
                }
            },
            'show_panel': function (tracker, msg) {
                bus.$emit('tracker_panel', {action: msg, tracker: tracker});
            },
            'load_tags': function () {
                var self = this;
                HTTP.get('/devicetags/',)
                    .then(function (re) {
                        self.tags = re.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            'tag_label': function (elem) {
                return elem.label
            },
            'on_select_tag': function (tag) {
                var self = this;
                HTTP.put('/devices/' + this.selected.id + '/tags/' + tag.id + '/',)
                    .then(function (re) {
                        var new_tag = re.data;
                        var idx = self.tags.findIndex(elem => elem.id == new_tag.id);
                        if (idx >= 0) {
                            self.tags[idx] = new_tag;
                            self.update_selected_tags();
                            console.log(self.tags)
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            'on_remove_tag': function (tag) {
                var self = this;
                HTTP.delete('/devices/' + this.selected.id + '/tags/' + tag.id + '/',)
                    .then(function (re) {
                        var new_tag = re.data;
                        var idx = self.tags.findIndex(elem => elem.id == new_tag.id);
                        if (idx >= 0) {
                            self.tags[idx] = new_tag;
                            self.update_selected_tags();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            'add_tag': function () {
                if (this.new_tag.label.length > 0) {
                    var self = this;
                    if (self.selected) {
                        self.new_tag.devices = [self.selected.id];
                    }
                    HTTP.post('/devicetags/', self.new_tag)
                        .then(function (re) {
                            var new_tag = re.data;
                            self.tags.push(new_tag);
                            self.update_selected_tags();
                            self.new_tag = {};
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            },
          show_temperature_link: function (tracker) {
            if (!tracker || tracker.type != 'tracker_01') {
              return false
            }

            if (!tracker.tracker_config.board_name || !tracker.tracker_config.board_name.startsWith('SCT2')){
              return false;
            }
            let version_array = tracker.version.match(/-(.*)\-/);
            if (!version_array){
              return false;
            }
            let version  = version_array.pop()
            if (semver.lt(version, "4.62.0")) {
              return false;
            }
            return true
          }
        },
        updated: function () {
            feather.replace();
        },
        mounted: function () {
            this.load_tags()
        },
        created: function() {
            var self = this
            bus.$on('tracker_panel', elem => {
                if (elem.action == 'map') {
                    self.select(elem.tracker)
                }
            })
        }
}
</script>